import { AuthenticationParameters } from 'msal';

export class AppConfig {
	public static AUTH_CLIENT_ID: string = "da0c5372-ecc2-4cc6-a8b1-d75e89effeba";
	public static AUTHORITY: string = "https://login.microsoftonline.com/tourism.collabo.tech";
	public static GRAPH_SCOPES: string[] = ["user.readwrite.all", "group.readwrite.all", "files.readwrite.all"];
	public static AUTH_PARAMETERS: AuthenticationParameters = {
		scopes: AppConfig.GRAPH_SCOPES
	};
	public static SUPER_ADMIN_IDS: string[] = ['41904497-04c1-41cb-afb2-2a5ea10a2bb5'];
	public static PERMITTED_GROUP_IDS: string[] = [
		'13aaf961-0703-4ad5-854c-06b73121b513', // いしかわ観光創造塾
		'7d255e5e-a399-4594-b42e-0b14176f3eb0' // 観光コア人材育成スクール
	];
	public static USER_SECUTIRY_GROUP_ID: string = "7d79a0f0-ea95-4b02-bcd0-c8266b2269b4"; // TODO 生徒
	public static ADMIN_SECUTIRY_GROUP_ID: string = "01a8b31d-0804-4d7d-a38f-52c7a29c7412"; // TODO 講師
	public static USER_ROOT_FOLDER_NAME: string = '生徒';
	public static ADMIN_ROOT_FOLDER_NAME: string = '運営';

	public static CHANNEL_ID_TO_CHNNAEL_FOLDERNAME: { [key: string]: string; } = {
		"19:442396d6fbac4518aaebafd6d34af0a0@thread.skype": "第01講 開講式",
		"19:8052608365de48c38ac53d75dd427138@thread.skype": "第02講 ファシリテーション演習",
		"19:35d1807f6ca546b9808d3574a41fb799@thread.skype": "第03講 資源開発フィールドワーク（地元学）",
		"19:26ac64317e5f411c9c503bdae49ff582@thread.skype": "第04講 資源開発フィールドワーク（地元学）",
		"19:6e6f1d22c7a048a5ac964427ea5ba139@thread.skype": "第05講 戦略的マネジメント ケースメソッドⅠ（ミニケース）",
		"19:55c56cc2736d4294b01784e6c032dbf7@thread.skype": "第06講 インバウンドの取組",
		"19:4dec076e7beb4a5ab65e364c267415b3@thread.skype": "第07講 実践的マーケティング論（基礎編）",
		"19:a9ef8ba551f14cf0a352ff1a8a06afe8@thread.skype": "第08講 ケースメソッドⅡ",
		"19:5943f1761b4a459f9bb17c709b16340f@thread.skype": "第09講 ケースメソッドⅡ",
		"19:f172799a302b4ee5801675dcb2713756@thread.skype": "第10講 アカウンティング論",
		"19:8bf8d15388fe44529ade43ae6c6d8bf8@thread.skype": "第11講 ファイナンス論",
		"19:5084d6fee9fe4b2988457ccbaf5084d1@thread.skype": "第12講 実践的マーケティング論（発展編）、実践的プランニング論",
		"19:33c93c19039b4f7ab46bf586e7414eae@thread.skype": "第13講 事業計画立案",
		"19:ed7f707dc461426c84b08857aa2a3f70@thread.skype": "第14講 事業計画立案、修了式",
		"19:6aece529113f4c8e9da2c9184ddfd108@thread.skype": "第01講 開講式",
		"19:03cb36b996c24231bb2c93231c58e1a2@thread.skype": "第02講 ファシリテーションマネジメント",
		"19:9866f21e15d141c79254bccf315ba1ca@thread.skype": "第03講 トップリーダーの講話と対話Ⅰ",
		"19:65f0e704195d47eda3e51eddfdee1f2b@thread.skype": "第04講 アカウンティング",
		"19:e719b7aec77d414eb92999709a5166f4@thread.skype": "第05講 ファイナンス",
		"19:f2d29097cf4f4f20be79cb60f8d7fefb@thread.skype": "第06講 ホスピタリティイノベーション",
		"19:14a9230b2f4f4848ac98d3a4a790cae6@thread.skype": "第07講 観光サービス創造マネジメント",
		"19:ea2e6ce30a784ab3a53558ab9929983c@thread.skype": "第08講 ケースメソッドサービス創出",
		"19:4adabeff4c764c4ebb60757c23da76fb@thread.skype": "第09講 トップリーダーの講話と対話Ⅱ",
		"19:78fc4fdbddd4494c8140e8172c8b90ab@thread.skype": "第10講 観光サービス創造演習",
		"19:48018ea55b1348fbbc5a7df5209bec98@thread.skype": "第11講 修了式"
	};

	public static CHANNEL_ID_TO_SHORTEN_NAME: { [key: string]: string; } = {
		"19:442396d6fbac4518aaebafd6d34af0a0@thread.skype": "2019_SCT_01",
		"19:8052608365de48c38ac53d75dd427138@thread.skype": "2019_SCT_02",
		"19:35d1807f6ca546b9808d3574a41fb799@thread.skype": "2019_SCT_03",
		"19:26ac64317e5f411c9c503bdae49ff582@thread.skype": "2019_SCT_04",
		"19:6e6f1d22c7a048a5ac964427ea5ba139@thread.skype": "2019_SCT_05",
		"19:55c56cc2736d4294b01784e6c032dbf7@thread.skype": "2019_SCT_06",
		"19:4dec076e7beb4a5ab65e364c267415b3@thread.skype": "2019_SCT_07",
		"19:a9ef8ba551f14cf0a352ff1a8a06afe8@thread.skype": "2019_SCT_08",
		"19:5943f1761b4a459f9bb17c709b16340f@thread.skype": "2019_SCT_09",
		"19:f172799a302b4ee5801675dcb2713756@thread.skype": "2019_SCT_10",
		"19:8bf8d15388fe44529ade43ae6c6d8bf8@thread.skype": "2019_SCT_11",
		"19:5084d6fee9fe4b2988457ccbaf5084d1@thread.skype": "2019_SCT_12",
		"19:33c93c19039b4f7ab46bf586e7414eae@thread.skype": "2019_SCT_13",
		"19:ed7f707dc461426c84b08857aa2a3f70@thread.skype": "2019_SCT_14",
		"19:6aece529113f4c8e9da2c9184ddfd108@thread.skype": "2019_SCTCB_01",
		"19:03cb36b996c24231bb2c93231c58e1a2@thread.skype": "2019_SCTCB_02",
		"19:9866f21e15d141c79254bccf315ba1ca@thread.skype": "2019_SCTCB_03",
		"19:65f0e704195d47eda3e51eddfdee1f2b@thread.skype": "2019_SCTCB_04",
		"19:e719b7aec77d414eb92999709a5166f4@thread.skype": "2019_SCTCB_05",
		"19:f2d29097cf4f4f20be79cb60f8d7fefb@thread.skype": "2019_SCTCB_06",
		"19:14a9230b2f4f4848ac98d3a4a790cae6@thread.skype": "2019_SCTCB_07",
		"19:ea2e6ce30a784ab3a53558ab9929983c@thread.skype": "2019_SCTCB_08",
		"19:4adabeff4c764c4ebb60757c23da76fb@thread.skype": "2019_SCTCB_09",
		"19:78fc4fdbddd4494c8140e8172c8b90ab@thread.skype": "2019_SCTCB_10",
		"19:48018ea55b1348fbbc5a7df5209bec98@thread.skype": "2019_SCTCB_11"
	};

	public static BUCKET_NAME_PRETASK: string = '事前課題';
	public static BUCKET_NAME_PRETASK2: string = '事前課題２';
	public static BUCKET_NAME_PRETASK3: string = '事前課題３';
	public static BUCKET_NAME_LECTURE: string = '講義';
	public static BUCKET_NAME_POSTTASK: string = '事後課題';

	public static USER_TASK_NAME_CHECK_TASK: string = '課題確認';
	public static USER_TASK_NAME_SUBMIT_REPORT: string = 'レポート提出';
	public static USER_TASK_NAME_CHECK_SCORE: string = '採点結果確認';
	public static USER_TASK_NAME_CHECK_DOCS: string = '講義資料確認';
	public static USER_TASK_NAME_CHECK_VIDEOS: string = '講義動画確認';

	public static ADMIN_TASK_NAME_SCORE_REPORT: string = 'レポート採点';
	public static ADMIN_TASK_NAME_GIVE_LECTURE: string = '講義開催';

	public static USER_TASK_FOLDERNAME_SUBMITREPORT: string = '提出レポート';
	public static USER_TASK_FOLDERNAME_CHECKSCORE: string = '採点結果';


	public static ADMIN_TASK_ITEMS: string[] = [
		"課題作成",
		"課題登録",
		"レポートフォーマット登録",
		"レポート採点", // 開始日-1が提出期限
		"講義資料作成",
		"講義資料登録",
		"講義動画登録",
		"講義開催" // 講義日
	];
	public static USER_TASK_ITEMS: string[] = [
		"課題確認",
		"レポート作成", // 提出期限?
		"レポート提出", // 提出期限
		"採点確認",
		"講義資料確認",
		"講義動画確認",
		"講義参加" // 講義日
	];
}
